<template>
  <div>
    <div v-if="question.content" v-html="question.content.replace(/  /g, '&nbsp;')" class="question__content"></div>
      
    <template v-if="question.image != 0">
      <b-img-lazy thumbnail :src="cdnUrl + question.image" width="256"></b-img-lazy>
    </template>

    <template v-if="editable">
      <div class="my-1">
        <div
          v-for="(answer, indexAnswer) in question.answers"
          :key="answer.id"
        >
          <b-button
            pill
            variant="light"
            :class="'mt-1 btn__exam' + ((isSelected === answer.id) ? ' btn__exam--selected' : '')"
            @click="selectQuestionAnswer(answer.id)"
          >
            <span>{{ (indexAnswer + 1 + 9).toString(36).toUpperCase() }}. </span>
            <span v-html="answer.content.replace(/ /g, '&nbsp;')"></span>
          </b-button>

          <b-img-lazy thumbnail v-if="answer.attachment_image != '0' && answer.attachment_image != null" :src="cdnUrl + answer.attachment_image" width="256"></b-img-lazy>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="my-1">
        <div
          v-for="(answer, indexAnswer) in question.answers"
          :key="answer.id"
        >
          <template v-if="answer.is_answer">
            <b-button
              pill
              variant="light"
              :class="'mt-1 btn__exam btn__exam--right'"
            >
              <span>{{ (indexAnswer + 1 + 9).toString(36).toUpperCase() }}. </span>
              <span v-html="answer.content"></span>
            </b-button>
          </template>
          <template v-else>
            <b-button
              pill
              variant="light"
              :class="'mt-1 btn__exam' + ((response.answer_id === answer.id) ? ' btn__exam--exam_no' : '')"
            >
              <span>{{ (indexAnswer + 1 + 9).toString(36).toUpperCase() }}. </span>
              <span v-html="answer.content"></span>
            </b-button>
          </template>

          <b-img-lazy thumbnail v-if="answer.attachment_image != '0' && answer.attachment_image != null" :src="cdnUrl + answer.attachment_image" width="256"></b-img-lazy>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionReadingSelect',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isSelected: false
    }
  },
  methods: {
    selectQuestionAnswer(a_id) {
      this.isSelected = a_id;

      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer_id: a_id
      })
    }
  }
}
</script>